import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'
import { RichTextEditor, RichTextEditorHandle } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import i18n from 'modules/core/lib/i18n'

import DirectUploader from 'modules/trainings/components/Files/Uploaders/DirectUploader'
import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { ContentModule } from 'modules/trainings/lib/content/Module'

const ModuleEditor = observer(({ contentItem, trainingId }: ContentEditorProps<ContentModule>) => {
  const descriptionRichTextEditorRef = React.useRef<RichTextEditorHandle>(null)
  const { editorConfig, canUseRichTextEditor, loading: richTextEditorLoading } = useRichTextEditor()

  const initialFile = contentItem.thumbnail
    ? contentItem.thumbnail.toFileObject('image/jpeg')
    : undefined

  return (
    <>
      <Input
        label={i18n.t('trainings.content.module_modal.label_title')}
        onChange={(value: string) => {
          contentItem.title = value
        }}
        placeholder={i18n.t('trainings.content.module_modal.label_placeholder')}
        value={contentItem.title}
        required
      />

      <Box className="gap-2">
        <Box style={{ position: 'relative', overflow: 'hidden' }}>
          {richTextEditorLoading ? (
            <RichTextEditor.Skeleton />
          ) : canUseRichTextEditor ? (
            <RichTextEditor
              ref={descriptionRichTextEditorRef}
              {...editorConfig}
              onChange={(data) => (contentItem.description = data?.value || '')}
              placeholder={i18n.t('trainings.content.module_modal.description_placeholder')}
              initialEditorState={{ content: contentItem.description || '' }}
              title={i18n.t('trainings.content.module_modal.description_title')}
              fullScreenMode
            />
          ) : (
            <Textarea
              label={i18n.t('trainings.content.module_modal.description_title')}
              onChange={(value: string) => {
                contentItem.description = value
              }}
              placeholder={i18n.t('trainings.content.module_modal.description_placeholder')}
              value={contentItem.description || ''}
            />
          )}
        </Box>
      </Box>

      <Box className="gap-2">
        <Box className="gap-1">
          <label className="font-medium text-f1-foreground-secondary">
            {i18n.t('trainings.content.module_modal.upload_label')}
          </label>
          <span className="text-base text-f1-foreground-secondary">
            {i18n.t('trainings.content.module_modal.upload_description')}
          </span>
        </Box>
        <DirectUploader
          onUpload={async (uploadData) => {
            contentItem.thumbnail = AttachedFile.fromUpload(
              uploadData.file,
              uploadData.signedId || ''
            )
          }}
          onDelete={() => {
            contentItem.thumbnail = undefined
          }}
          description={i18n.t('trainings.content.module_modal.upload_file_description')}
          fileTypes={['image' as const]}
          resourceType={'Trainings::Training'}
          resourceId={String(trainingId)}
          initialFile={initialFile}
        />
      </Box>
    </>
  )
})

export { ModuleEditor }
